var InputType;
(function (InputType) {
    InputType["EMAIL"] = "email";
    InputType["NUMBER"] = "number";
    InputType["PASSWORD"] = "password";
    InputType["SEARCH"] = "search";
    InputType["TEXT"] = "text";
    InputType["URL"] = "url";
})(InputType || (InputType = {}));
export default InputType;
//# sourceMappingURL=input-type.js.map